module.exports = __webpack_public_path__ + "img/Indonesia-04.dbd42951.jpg";